module.exports = __webpack_public_path__ + "static/2front-development-2-12055f97eb2248a5cfa9720e16093741.png";